import styled from "styled-components";
import { Button as AntButton, Modal as AntModal } from "antd";

export const CopyLink = styled.a`
	display: block;
	color: #616161;
	text-align: center;
	font-size: 15px;
	font-style: normal;
	font-weight: 400;
	line-height: 1.5; 

	:hover {
		color: #616161;
		text-decoration: underline;
	}
`;

export const CopyTitle = styled.p`
	margin-bottom: 10px;
	color: #1E1E1E;
	text-align: center;
	font-size: 18px;
	font-style: normal;
	font-weight: 700;
	line-height: 30px; /* 150% */
`;

export const Modal = styled(AntModal)`
	.ant-modal-content {
		padding-top: 116px !important;
		background: #fff !important;
		border: none !important;
	}

	.ant-modal-body {
		padding: 0 !important;
	}

	#modal-icon {
		width: 90px !important;
		top: -10px !important;
	}
`;


export const TitleLinkWrapper = styled.div`
 padding-bottom: 16px;
`;

export const ButtonWrapper = styled.div`
	display:flex;
	justify-content: center;
	align-items: center;
	gap: 10px;
`;

export const ButtonDiv = styled(AntButton)`
	display: flex;
	justify-content: center;
	align-items: center;
	flex: 1;
	cursor: pointer;

	border-radius: 16px;
	height: 50px;
`;